import XRegExp from 'xregexp';
import {removeTagsFromText} from '../../pages/branding/emailSubjectTextEditor/EmailSubjectTextEditor.js';
import {replaceVariablesInDelta, deltaToHtml} from './Variables.js';

export const cleanText = (text) => {
    const regexPattern = XRegExp('[' +
        '\\x00-\\x09' +   // ASCII Control characters from 0x00 to 0x09
        '\\x0B-\\x1F' +   // ASCII Control characters from 0x0B to 0x1F
        '\\x7F-\\x9F' +   // More control characters
        '\\u00A0' +       // Non-breaking space
        '\\u200B-\\u200F' + // Zero-width space and bidirectional text controls
        '\\u00AD' +       // Soft hyphen
        '\\u2060' +       // Word joiner
        '\\uFEFF' +       // Zero width no-break space (Byte Order Mark)
    ']', 'g');

    const cleanedText = XRegExp.replace(text, regexPattern, '');
    return cleanedText;
};

export const decodeHtmlEntities = (text) => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
};

export const removeHiddenSpace = (string) => 
    string.split('').filter((_, index) => string.charCodeAt(index) !== 65279).join('');

export const clearText = (string) => removeTagsFromText(removeHiddenSpace(string));

export const convertTextBeforeSave = (quillRef) => {
    if(!quillRef.current) return '';
    const quill = quillRef.current.getEditor();
    if(!quill) return '';
    const delta = quill.getContents();
    const contentWithPlaceholders = replaceVariablesInDelta(delta);
    const htmlOutput = deltaToHtml(contentWithPlaceholders);
    return htmlOutput;
};

export const hasDisabledVariables = (quillRef, disabledVariables) => {
    const quill = quillRef?.current?.getEditor();
    if(quill) {
        const html = quill?.root?.innerHTML;
        return Object.keys(disabledVariables).some((key) => html.includes(`data-label="${key}"`));
    }
    return false;
};

export const SANITIZE_CONFIG = {
    ALLOWED_TAGS: ['p', 'br', 'span', 'a', 'strong', 'em', 'u', 's', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'blockquote', 'code', 'pre', 'img', 'iframe'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'data-label', 'src', 'alt', 'style', 'allow', 'allowfullscreen', 'frameborder', 'width', 'height']
};

